/**
 * Elaara – Gift Wrap PDP
 * Intercepts the product form submit, adds main product + gift wrap to cart,
 * then fires the exact same 'cart:update' event the theme uses so the
 * cart drawer re-renders and opens automatically.
 */

(function () {
  'use strict';

  function initGiftWrapPDP() {
    var widgets = document.querySelectorAll('.elaara-gift-wrap-pdp');
    if (!widgets.length) return;

    widgets.forEach(function (widget) {
      var checkbox     = widget.querySelector('.elaara-gift-wrap-pdp__checkbox');
      var messageWrap  = widget.querySelector('.elaara-gift-wrap-pdp__message-wrap');
      var messageInput = widget.querySelector('.elaara-gift-wrap-pdp__message-input');
      var charRemain   = widget.querySelector('.elaara-gift-wrap-pdp__char-remaining');

      if (!checkbox) return;

      /* ── toggle message box ── */
      checkbox.addEventListener('change', function () {
        var checked = checkbox.checked;
        checkbox.setAttribute('aria-expanded', String(checked));
        if (checked) {
          messageWrap.removeAttribute('hidden');
          messageWrap.setAttribute('aria-hidden', 'false');
        } else {
          messageWrap.setAttribute('hidden', '');
          messageWrap.setAttribute('aria-hidden', 'true');
        }
      });

      /* ── character counter ── */
      if (messageInput && charRemain) {
        messageInput.addEventListener('input', function () {
          charRemain.textContent = 250 - messageInput.value.length;
        });
      }

      /* ── intercept ATC ── */
      var productForm = findProductForm(widget);
      if (!productForm) return;

      productForm.addEventListener('submit', function (e) {
        if (!checkbox.checked) return; // gift wrap not selected – let native flow run

        e.preventDefault();
        e.stopImmediatePropagation();

        var giftVariantId = widget.dataset.giftWrapVariantId;
        var productTitle  = widget.dataset.productTitle || '';
        var giftMessage   = messageInput ? messageInput.value.trim() : '';

        if (!giftVariantId) {
          // Safety fallback
          checkbox.checked = false;
          productForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
          return;
        }

        var submitBtn  = productForm.querySelector('[type="submit"][name="add"]');
        var cartDrawer = document.querySelector('hdt-cart-drawer');
        var sectionId  = cartDrawer ? cartDrawer.getAttribute('section-id') : null;
        var cartRoot   = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var headers    = { 'Content-Type': 'application/json' };

        setLoading(submitBtn, true);

        // Build main product payload (mirror what theme's ProductForm does)
        var formData    = new FormData(productForm);
        var mainPayload = {
          id:         formData.get('id'),
          quantity:   parseInt(formData.get('quantity') || '1', 10),
          properties: {},
          sections:   sectionId || '',
        };
        for (var pair of formData.entries()) {
          var k = pair[0], v = pair[1];
          if (k.startsWith('properties[') && k.endsWith(']')) {
            mainPayload.properties[k.slice(11, -1)] = v;
          }
        }

        // Build gift wrap payload
        var giftProperties = { 'For Product': productTitle };
        if (giftMessage) giftProperties['Gift Message'] = giftMessage;

        var giftPayload = {
          id:         parseInt(giftVariantId, 10),
          quantity:   1,
          properties: giftProperties,
          sections:   sectionId || '',
        };

        /* Step 1 – add main product */
        fetch(cartRoot + 'cart/add.js', {
          method:  'POST',
          headers: headers,
          body:    JSON.stringify(mainPayload),
        })
        .then(function (r) { return r.json(); })
        .then(function (mainData) {
          if (mainData.status) {
            setLoading(submitBtn, false);
            productForm.dispatchEvent(new CustomEvent('cart:add:error', {
              bubbles: true,
              detail: {
                error: mainData.description || mainData.message || 'Could not add to cart.',
                isGiftCardRecipient: false,
              },
            }));
            return Promise.reject('add_error');
          }

          /* Step 2 – add gift wrap */
          return fetch(cartRoot + 'cart/add.js', {
            method:  'POST',
            headers: headers,
            body:    JSON.stringify(giftPayload),
          });
        })
        .then(function (r) { return r ? r.json() : null; })
        .then(function (giftData) {
          if (!giftData) return;

          setLoading(submitBtn, false);

          // Determine actionAfterATC from theme settings (same logic as theme)
          var actionAfterATC = (window.themeHDN &&
                                window.themeHDN.settings &&
                                window.themeHDN.settings.actionAfterATC) || 'open_cart_drawer';

          // The CartDrawer listens for 'cart:update' (ThemeEvents.cartUpdate).
          // It opens when: source === 'product-form-component' AND actionAfterATC === 'open_cart_drawer'
          // It also needs cartData.sections[sectionId] to contain the re-rendered HTML.
          //
          // /cart/add.js with sections param returns sections in the response.
          // Use giftData if it has sections; otherwise fall back to cart/update.js.

          if (sectionId && giftData.sections && giftData.sections[sectionId]) {
            fireCartUpdate(giftData, actionAfterATC);
          } else {
            // Fallback: cart/update.js (note: NOT /cart/update — the JS endpoint)
            fetch(cartRoot + 'cart/update.js', {
              method:  'POST',
              headers: headers,
              body:    JSON.stringify({ sections: sectionId ? [sectionId] : [] }),
            })
            .then(function (r) { return r.json(); })
            .then(function (cartData) { fireCartUpdate(cartData, actionAfterATC); })
            .catch(function (err) { console.error('[Elaara Gift Wrap] fallback failed:', err); });
          }
        })
        .catch(function (err) {
          if (err !== 'add_error') {
            console.error('[Elaara Gift Wrap]', err);
            setLoading(submitBtn, false);
          }
        });

      }, true /* capture – run before theme's listener */);
    });
  }

  /**
   * Fire the exact 'cart:update' event the theme's CartDrawer listens for.
   * Signature from events.js CartUpdateEvent / CartAddEvent:
   *   new Event('cart:update', { bubbles: true })
   *   event.detail = { resource, sourceId, cartData, actionAfterATC, source, data }
   */
  function fireCartUpdate(cartData, actionAfterATC) {
    var evt = new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource:       {},
        sourceId:       '',
        cartData:       cartData,
        actionAfterATC: actionAfterATC,
        source:         'product-form-component',
        data:           {},
      },
    });
    document.dispatchEvent(evt);
  }

  function findProductForm(widget) {
    var scope = widget.closest('.shopify-section') ||
                widget.closest('[data-section-id]') ||
                document.body;
    return scope.querySelector('form.hdt-main-product-form') ||
           scope.querySelector('[class*="hdt-main-product-form"]') ||
           scope.querySelector('form[action*="cart/add"]');
  }

  function setLoading(btn, on) {
    if (!btn) return;
    if (on) {
      btn.setAttribute('disabled', 'true');
      btn.setAttribute('aria-busy', 'true');
    } else {
      btn.removeAttribute('disabled');
      btn.removeAttribute('aria-busy');
    }
  }

  /* ── Boot ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGiftWrapPDP);
  } else {
    initGiftWrapPDP();
  }

  document.addEventListener('shopify:section:load', function () {
    setTimeout(initGiftWrapPDP, 100);
  });

})();
